import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http/http-client.service';

const API_LOGIN = environment.url_login;
const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AuthCustomService {

  constructor(private httpService: HttpService) { }

  customerWL(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGetPath(API_LOGIN + '/auth/customer', data, successHandle, errorHandle);
  }  

}
